import styled from 'styled-components'

interface IProfileTagProps {
  color: string
}

export const ProfileTag = styled.span<IProfileTagProps>`
  background-color: ${(props) => props.color}40;
  padding: 8px 8px;
  border-radius: 8px;
  font-size: 12px;
  svg {
    cursor: pointer;
    transition: 200ms;
  }
  svg:hover {
    opacity: 0.7;
  }
`

export const StateAlert = styled.div`
  margin-top: 16px;
  padding: 10px 12px;
  border-radius: 8px;
  background-color: #e7f3fe;
  color: #363636;
  font-size: 14px;
  svg {
    color: #213f68;
    margin-right: 10px;
  }
`
